import { useMutation, useQueryClient } from "@tanstack/react-query";
import apiClient from "../../api/client";

export function useUpdateDetection() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ detectionId, field, value }) => {
      // Map field names to API endpoints
      const endpoints = {
        user_confirmed: "confirm",
        field_confirmed: "field_check",
        field_solved: "solve",
      };
      const endpoint = endpoints[field];
      if (!endpoint) {
        throw new Error(`Unknown field: ${field}`);
      }
      const { data } = await apiClient.patch(
        `api/detected-malfunctions/${detectionId}/${endpoint}/`,
        { [field]: value }
      );
      return data;
    },
    onSuccess: () => {
      // Refresh both videos (to update detection counts) and individual detections
      queryClient.invalidateQueries({ queryKey: ["videos"] });
      queryClient.invalidateQueries({ queryKey: ["detections"] });
    },
    onError: (error) => {
      console.error("Error updating detection:", error);
    },
  });
}